var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_builder"},_vm._l((_vm.sections),function(section,index){return _c(`section-${section.key}`,{key:index,tag:"component",staticClass:"content_section",attrs:{"value":section.value,"article":_vm.article,"exclude-from-print-class-name":_vm.excludeFromPrintClassName}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }